/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ConversationTurn {
  TheirTurn = "their_turn",
  OurTurn = "our_turn",
}

export function instanceOfConversationTurn(value: any): boolean {
  for (const key in ConversationTurn) {
    if (Object.prototype.hasOwnProperty.call(ConversationTurn, key)) {
      if (ConversationTurn[key as keyof typeof ConversationTurn] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ConversationTurnFromJSON(json: any): ConversationTurn {
  return ConversationTurnFromJSONTyped(json, false);
}

export function ConversationTurnFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationTurn {
  return json as ConversationTurn;
}

export function ConversationTurnToJSON(value?: ConversationTurn | null): any {
  return value as any;
}

export function ConversationTurnToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ConversationTurn {
  return value as ConversationTurn;
}
